import {
  Dropdown,
  Field,
  Input,
  Option,
  makeStyles,
} from '@fluentui/react-components';
import { FIELD_LABEL_LAYOUT } from '@moko/ui';
import type { IPricingTier } from '../../services/settingsService';

export type TenantPricingValue = {
  pricingTierId: number | null;
  pricingDiscountPercentage: number | null;
};

export interface TenantPricingFieldsProps {
  value: TenantPricingValue;
  tiers: IPricingTier[];
  onChange: (value: TenantPricingValue) => void;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '12px',
    width: '100%',
    maxWidth: '520px',
  },
  control: {
    minWidth: 'auto',
    width: '100%',
  },
});

const TenantPricingFields = ({
  value,
  tiers,
  onChange,
}: TenantPricingFieldsProps) => {
  const styles = useStyles();
  const selected = tiers.find((tier) => tier.id === value.pricingTierId);
  const tierLabel = selected?.name || selected?.code || '';

  return (
    <div className={styles.root}>
      <Field
        label="Pricing tier"
        orientation="horizontal"
        style={FIELD_LABEL_LAYOUT}
      >
        <Dropdown
          className={styles.control}
          value={tierLabel}
          selectedOptions={
            value.pricingTierId == null ? [] : [String(value.pricingTierId)]
          }
          onOptionSelect={(_, data) => {
            const next = data.optionValue ? Number(data.optionValue) : null;
            onChange({
              ...value,
              pricingTierId: Number.isFinite(next) ? next : null,
            });
          }}
        >
          {tiers
            .filter((tier) => tier.id != null)
            .map((tier) => (
              <Option key={tier.id} value={String(tier.id)}>
                {tier.name || tier.code}
              </Option>
            ))}
        </Dropdown>
      </Field>
      <Field
        label="Discount %"
        orientation="horizontal"
        style={FIELD_LABEL_LAYOUT}
      >
        <Input
          className={styles.control}
          type="number"
          value={
            value.pricingDiscountPercentage == null
              ? ''
              : String(value.pricingDiscountPercentage)
          }
          onChange={(_, data) => {
            if (data.value === '') {
              onChange({ ...value, pricingDiscountPercentage: null });
              return;
            }
            const parsed = Number(data.value);
            onChange({
              ...value,
              pricingDiscountPercentage: Number.isFinite(parsed)
                ? parsed
                : null,
            });
          }}
        />
      </Field>
    </div>
  );
};

export default TenantPricingFields;
